import {
    defaultGrid,
    featuredGrid,
    featuredGrid_noLimit,
    defaultSideScroll,
    featuredVerticalRightCol_noLimit,
    featuredDesc_noLimit,
} from "./base_gridLayouts";
import { CardRegular } from "../../Card/components/CardRegular/component";
import CardDefault from "../../Card/components/CardDefault/component";
import CardShow from "../../Card/components/CardShow/component";
import {
    CardFeaturedVideoEnabled,
    CardFeaturedAuthorVideoEnabled,
} from "../../Card/components/GetVideoPlayerForCard/component";
import CardListing from "../../Card/components/CardListing/component";
//Configure the grid layouts with card components
export const default_CardRegular = defaultGrid.selectComponents(CardRegular);
export const default_CardDefault = defaultGrid.selectComponents(CardDefault);
export const default_CardShow = defaultGrid.selectComponents(CardShow);
export const featured_withCards = featuredGrid.selectComponents(CardRegular, [
    CardFeaturedVideoEnabled, // First card is CardFeatured
]);
export const featured_withCards_noLimit = featuredGrid_noLimit.selectComponents(
    CardRegular,
    [
        CardFeaturedVideoEnabled, // First card is CardFeatured
    ]
);

export const defaultSideScroll_CardRegular =
    defaultSideScroll.selectComponents(CardRegular);

export const featured_verticalRightCol_noLimit =
    featuredVerticalRightCol_noLimit.selectComponents(CardDefault, [
        CardFeaturedAuthorVideoEnabled,
    ]);

// Fix for FLP pages that have CardListing and don't display author info
// In such cases, we control displaying author info in cards through Control Panel KVPs
const CardListingAuthor = (props) => (
    <CardListing displayAuthor={true} {...props} />
);

export const featured_description = featuredDesc_noLimit.selectComponents(
    CardRegular,
    [
        CardFeaturedVideoEnabled,
        CardListingAuthor,
        CardListingAuthor,
        CardListingAuthor,
    ]
);

export const description = defaultGrid.selectComponents(CardListingAuthor);
